import axios from "axios";
import Modal from "react-modal";
import { AES } from 'crypto-js';
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import React, { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import pImage from "../../../../images/singleinvoice/print.svg";
import dImage from "../../../../images/singleinvoice/delete.svg";
import editImage from "../../../../images/singleinvoice/edit.svg";
import invStatusConsts from "../../../../constants/invStatusConsts";
import { logout, reset } from "../../../../features/auth/authSlice";
import crssrImage from "../../../../images/singleinvoice/cross-red.svg";
import dowImage from "../../../../images/singleinvoice/download_icon.svg";
import { reset as invoiceReset } from "../../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../../features/appSettings/appSettingsSlice.js";
import { INVOICE_STATUS } from "../../../../constants/invoice.js";

const InvoiceActions = (props) => {
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [isCreatingPdf, setIsCreatingPdf] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [selectedVenInvId, setSelectedVenInvId] = useState("");
  const user = useSelector(
    (state) => state.auth.user
  )
  let token = null;
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }

  const PENDING = 0;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let encodedId;
  let invId;

  const handlePrint = async () => {
    if (isPrinting) return;
    setIsPrinting(true);
    try {
      await axios.post(`/api/vendor/invoice/create/pdf`, props.invoiceView, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const response = await axios.get(`/api/vendor/invoice/download/created/pdf`, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      });
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const printWindow = window.open(pdfUrl, "_blank");
      if (printWindow) {
        printWindow.addEventListener("load", () => {
          printWindow.focus();
          printWindow.print();
          URL.revokeObjectURL(pdfUrl);
        });
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to prepare print.", { position: "bottom-right", autoClose: 3000 });
    } finally {
      setIsPrinting(false);
    }
  };

  const createPdf = async (e) => {
    e.preventDefault();
    setIsCreatingPdf(true); // Set loading state to true

    try {
      await axios.post(`/api/vendor/invoice/create/pdf`, props.invoiceView, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const response = await axios.get(`/api/vendor/invoice/download/created/pdf`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const filename = `${props.invoiceData.ven_inv_number}.pdf`;
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      saveAs(pdfBlob, filename);
      toast.success(`Invoice "${props.invoiceData.ven_inv_number}" downloaded successfully!`, {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      global.config.activityLog(
        window.location.href,
        "Invoice",
        `Invoice "${props.invoiceData.ven_inv_number}" Downloaded Successfully!`
      );
    } catch (error) {
      console.error(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      // Display an error message to the user
      alert("Something went wrong while creating the PDF.");
    } finally {
      setIsCreatingPdf(false); // Set loading state to false, regardless of success or failure
    }
  };

  if (props.invoiceData) {
    const encryptedId = AES.encrypt(props.invoiceData._id, 'encryptionKey').toString();
    const encryptedVenId = AES.encrypt(props.invoiceData.ven_inv_for._id, 'encryptionKey').toString();
    const invId = encodeURIComponent(encryptedId).replace(/\//g, '%2F');
    const encodedId = encodeURIComponent(encryptedVenId).replace(/\//g, '%2F');
  }

  const handleDeleteInvoice = async (id) => {
    setSelectedVenInvId(id);
    setDeleteModalIsOpen(true);
  };

  const handleModalConfirm = async () => {
    try {
      setIsSubmitLoading(true);
      await axios.get(
        `/api/vendor/delete/invoice/${selectedVenInvId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success('Vendor invoice removed successfully!', {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      global.config.activityLog(
        window.location.href,
        "Invoice",
        `Invoice "${props.invoiceData.ven_inv_number}" removed Successfully!`
      );
      navigate(`/vendor/invoices/${encodeURIComponent(AES.encrypt(props.invoiceData && props.invoiceData.ven_inv_for && props.invoiceData.ven_inv_for._id, 'encryptionKey').toString().replace(/\//g, '%2F'))}`);
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error("Something went wrong", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setIsSubmitLoading(false);
    }
    setDeleteModalIsOpen(false);
  };

  const handleModalCancel = () => {
    setDeleteModalIsOpen(false);
  };

  return (
    <div className="s1-contain">
      <div className="bill-num-si">
        <a className="invoice-num-01">
          {props.invoiceData ? (
            props.invoiceData.ven_inv_number
          ) : (
            <div
              style={{
                width: "150px",
                height: "24px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          )}
        </a>
        {props.invoiceData && (props.invoiceData.ven_inv_status === invStatusConsts.Approved) && (<div className="approve-top">Approved</div>)}
        {props.invoiceData && (props.invoiceData.ven_inv_status === invStatusConsts.Rejected) && (<div className="reject-top">Rejected</div>)}
      </div>
      <div className="btn-aary">
        {props.invoiceData ? (
          (props.invoiceData.ven_inv_status === PENDING && props.invoiceData.ven_inv_payment_status !== INVOICE_STATUS.INVOICE_MANNUAL_PAYMENT) && (
            <Link className="editbtn-in-sle" to={`../edit/${encodeURIComponent(AES.encrypt(props.invoiceData._id, 'encryptionKey').toString().replace(/\//g, '%2F'))}/${encodeURIComponent(AES.encrypt(props.invoiceData.ven_inv_for._id, 'encryptionKey').toString().replace(/\//g, '%2F'))}`}>
              <img src={editImage} alt="Edit Icon" /> Edit Invoice
            </Link>
          )
        ) : (
          <div className="loader-in-action-btn-arry">
            <div
              style={{
                width: "120px",
                height: "36px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </div>
        )}

        {props.invoiceData ? (
          <a className="editbtn-in-slp" onClick={handlePrint} style={{ pointerEvents: isPrinting ? "none" : "auto" }}>
            {isPrinting ? <span className="inv-btn-dots"><span /><span /><span /></span> : <><img src={pImage} alt="printer Icon" /> Print</>}
          </a>
        ) : (
          <div className="loader-in-action-btn-arry">
            <div
              style={{
                width: "100px",
                height: "36px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </div>
        )}
        {props.invoiceData ? (
          <a className="editbtn-in-sldow" onClick={createPdf} style={{ pointerEvents: isCreatingPdf ? "none" : "auto" }}>
            {isCreatingPdf ? <span className="inv-btn-dots"><span /><span /><span /></span> : <><img src={dowImage} alt="Edit Icon" /> Download</>}
          </a>
        ) : (
          <div className="loader-in-action-btn-arry">
            <div
              style={{
                width: "120px",
                height: "36px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </div>
        )}
        {props.invoiceData && props.invoiceData._id ? (
          <a
            className="editbtn-in-sld"
            onClick={() => handleDeleteInvoice(props.invoiceData._id)}
          >
            {" "}
            <img src={dImage} alt="Edit Icon" /> Delete
          </a>
        ) : (
          <div className="loader-in-action-btn-arry">
            <div
              style={{
                width: "100px",
                height: "36px",
                backgroundColor: "#e5e7eb",
                borderRadius: "4px",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          </div>
        )}
      </div>
      {/* delete modal */}
      <Modal
        isOpen={deleteModalIsOpen}
        onRequestClose={!isSubmitLoading ? handleModalCancel : undefined}
        contentLabel="Confirm Deletion"
        style={{
          content: {
            height: "41%",
            width: "30%",
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            parent: document.querySelector(".admin-outer.time.tracker"),
          },
        }}
      >
        <div className="modal del-pop-modal">
          <div className="outter-modal-main delmodalicon">
            <a onClick={handleModalCancel} disabled={isSubmitLoading}>
              <img src={crssrImage} alt="Close Icon" />
            </a>
          </div>
          <h2>Confirm Deletion?</h2>
          <div>
            <div className="modal-content-del">
              <p>Are you sure you want to delete this Vendor Invoice?</p>
            </div>
            <div className="button-container btn-2-in-modal">
              <button className="buttons-rejected" onClick={handleModalConfirm} disabled={isSubmitLoading}>
                {isSubmitLoading ? (
                  <div className="outter-load-table">
                    <div
                      style={{
                        width: "18px",
                        height: "18px",
                        border: "2px solid white",
                        borderTop: "2px solid transparent",
                        borderRadius: "50%",
                        animation: "spin 0.8s linear infinite",
                      }}
                    />
                  </div>
                ) : (
                  "Delete"
                )}
              </button>
              <button className="Reject-singlebtn" onClick={handleModalCancel} disabled={isSubmitLoading}>
                Close
              </button>
            </div>
          </div>
        </div>
      </Modal>
      {/* modal end */}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </div>
  );
};

export default InvoiceActions;